/* eslint-disable no-unused-vars */
import { createSelector } from '@reduxjs/toolkit';

export const appNumberToPromote = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.app;
};

export const select_current_campaign_obj = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj;
};
export const selectedTargetingApps = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.target_apps_list;
};

//target section

export const selectTargetType = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.target_type;
};

export const selectShowErrorMessage = (state) => {
  return state?.targetingPlacements?.showErrorMessage;
};

export const selectTargetingTab = (state) => {
  return state?.targetingPlacements?.targetingSectionTabs;
};

export const selectTargettingErrorFlag = (state) => {
  return state?.targetingPlacements?.targetingError;
};

export const selectAllBrandsModels = (state) => {
  return state?.general?.mainCampaignObject?.all_brands_models;
};

export const selectAllBrands = (state) => {
  return state?.general?.mainCampaignObject?.all_brands;
};

export const selectBrands_audience_to_save = (state) => {
  return state.general.mainCampaignObject?.currentCampaignObj?.brands_audience_to_save;
};

export const select_change_flag = (state) => {
  return state?.targetingBrandsModels?.dataIsChanged;
};

export const select_current_min_version = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.userAgentsOSMinVer;
};

export const select_tab_osVersions = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.userAgentsOSType;
};

// export const select_os_all_versions = (state) => {
//   return state?.general?.mainCampaignObject?.userAgentOSs?.[1]?.map((item) => {
//     return { value: item.user_agent_os_id, label: item.user_agent_os_name };
//   });
// };

export const select_campaign_langs = (state) => {
  return state?.general?.mainCampaignObject?.campaignLangs;
};

export const userAgentsOSType = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.userAgentsOSType;
};

const getCurrentCampaignObj = (state) => state?.general?.mainCampaignObject?.currentCampaignObj;
const getMainCampaignObj = (state) => state?.general?.mainCampaignObject;

export const select_os_all_versions = createSelector([getMainCampaignObj], (mainCampaignObject) => {
  return mainCampaignObject?.userAgentOSs?.[1]?.map((item) => {
    return { value: item.user_agent_os_id, label: item.user_agent_os_name };
  });
});

export const select_userAgentsOSList = createSelector(
  [getCurrentCampaignObj],
  (currentCampaignObj) => {
    if (!currentCampaignObj?.userAgentsOSList) return [];
    return currentCampaignObj.userAgentsOSList.split(',').map((item) => +item);
  },
);

export const selected_os_versions = createSelector(
  select_os_all_versions,
  select_userAgentsOSList,
  (all_versions, selected_versions) => {
    return all_versions?.filter((version) => selected_versions.includes(version.value));
  },
);

export const campaignLangs = createSelector([getCurrentCampaignObj], (currentCampaignObj) => {
  if (!currentCampaignObj?.campaignLangs) return [];
  return currentCampaignObj.campaignLangs.split(',');
});

export const select_os_min_versions = createSelector([getMainCampaignObj], (mainCampaignObject) => {
  return (
    mainCampaignObject?.userAgentOSs?.[1]
      // ?.filter((item) => item.user_agent_os_id >= 32)
      ?.map((item) => {
        return { value: item.user_agent_os_id, label: item.user_agent_os_name };
      })
  );
});

export const selectedLocationsList = (state) => {
  return state?.general?.mainCampaignObject?.selected_locations;
};

export const select_all_countries_flag = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.location;
};

export const select_targeting_languages_tubs = (state) => {
  return state?.targetingLanguages?.type;
};

export const selected_custom_audience = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.customAudienceObj;
};

export const select_custom_audience_target_type = (state) => {
  return state?.general?.mainCampaignObject?.currentCampaignObj?.customAudience_IsInclude;
};

export const select_campaign_env = (state) => {
  return state?.general?.campaignEnvironment;
};

export const select_tier_locations = createSelector(
  (state) => state.general.mainCampaignObject?.tier1_locations || [],
  (state) => state.general.mainCampaignObject?.tier2_locations || [],
  (tier1, tier2) => {
    const arrays = [...tier1, ...tier2];
    const result_map = new Map();
    arrays.forEach((country) => {
      result_map.set(country.country_code, country.tier);
    });
    return result_map;
  },
);

const select_is_CPI = (state) => state.general.mainCampaignObject.currentCampaignObj.bidType;

const select_currently_selected_apps = (state) =>
  state.general.mainCampaignObject.currently_selected_apps;

const select_selected_locations = (state) => state.general.mainCampaignObject.selected_locations;

export const selectMinimumBidAndErrorMessage = createSelector(
  [select_currently_selected_apps, select_selected_locations, select_is_CPI],
  (currently_selected_apps, selected_locations, is_CPI) => {
    if (is_CPI !== 3) return null;
    if (!currently_selected_apps.length) return null;
    const selected_countries_set = new Set(
      selected_locations.map(({ country_code }) => country_code),
    );
    const selected_apps_with_bid_settings = currently_selected_apps.filter((app) => {
      return (
        app.appMinimumServingDefault.pba_number !== 0 || app.appMinimumServingPerCountry.length
      );
    });

    const minBidValuePerApp =
      selected_apps_with_bid_settings.length > 0
        ? Math.max(
            ...selected_apps_with_bid_settings.map(
              (app) => app.appMinimumServingDefault.direct_min_cpi,
            ),
          )
        : null;

    const app_names_set = new Set(
      selected_apps_with_bid_settings
        .filter((app) => app.appMinimumServingDefault.direct_min_cpi === minBidValuePerApp)
        .map((app) => {
          return `${app.pba_name} (${app.pba_number})`;
        }),
    );

    let minBidValuePerCountry = null;
    const country_names_set = new Set();

    selected_apps_with_bid_settings.forEach((app) => {
      app.appMinimumServingPerCountry.forEach(({ direct_min_cpi, location }) => {
        if (selected_countries_set.has(location.country_code)) {
          if (minBidValuePerCountry === null || direct_min_cpi > minBidValuePerCountry) {
            minBidValuePerCountry = direct_min_cpi;
            country_names_set.clear();
          }
          if (direct_min_cpi === minBidValuePerCountry) {
            country_names_set.add(location.country_name);
          }
        }
      });
    });

    let msg = '';
    if (minBidValuePerApp > minBidValuePerCountry) {
      msg = `The minimum bid for ${[...app_names_set].join(
        ', ',
      )} is not met. Increase your bid or remove targeting.`;
    }
    if (minBidValuePerCountry > minBidValuePerApp) {
      msg = `The minimum bid for ${[...country_names_set].join(
        ', ',
      )} is not met. Increase your bid or remove targeting.`;
    }
    if (minBidValuePerCountry === minBidValuePerApp) {
      msg = `The minimum bid for ${[...app_names_set].join(', ')} in ${[...country_names_set].join(
        ', ',
      )} is not met. Increase your bid or remove targeting.
 `;
    }
    return { msg, minBid: Math.max(minBidValuePerApp, minBidValuePerCountry) };
  },
);

export const select_is_directBuy = createSelector(
  [select_currently_selected_apps, selectTargetType],
  (selected_apps, target_type) => {
    if (target_type === 1) return false;
    return selected_apps?.length > 0;
  },
);
